import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/** Which (mutually exclusive) header overlay is currently open. */
export type ShellPanel = 'none' | 'notifications' | 'profile';

/**
 * Coordinates the header overlays (notification panel, profile popover) so opening
 * one closes the other. This replaces the cross-talk that used to live as shared fields on
 * AppComponent, now shared cleanly between the extracted shell components.
 */
@Injectable({ providedIn: 'root' })
export class ShellOverlayService {
  private readonly _open = new BehaviorSubject<ShellPanel>('none');
  readonly open$ = this._open.asObservable();

  toggle(panel: ShellPanel): void {
    this._open.next(this._open.value === panel ? 'none' : panel);
  }

  close(): void {
    this._open.next('none');
  }
}
